module.exports = __webpack_public_path__ + "img/logo.b3a56715.png";